export default __webpack_public_path__ + "static/media/pomegranateShot.7287180e.jpg";